import React, { useCallback } from 'react';
import DialogWindow from '../../../../Elements/DialogWindow/DialogWindow';
import DialogCloseButton from '../../../../Elements/DialogWindow/DialogCloseButton';
import DataTable from '../../../../Elements/DataTable/DataTableFigma';
import FactChips from '../../../../Elements/FactChips';
import Loading from '../../../../Elements/loading';
import InvoiceAutomationService from '../../../../Services/InvoiceAutomationService';
import InvoiceAutomationRunItem from '../../../../Domain/ThirdParty/Project/InvoiceAutomationRunItem';
import InvoiceAutomationRunChangeItem from '../../../../Domain/ThirdParty/Project/InvoiceAutomationRunChangeItem';
import useBackendData from '../../../../Helpers/useBackendData';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import InvoiceAutomationRunResult from './InvoiceAutomationRunResult';
import InvoiceAutomationRunSettings from './InvoiceAutomationRunSettings';

// One run of a project's automatic invoicing opened from its History, over the whole width of the window: who started
// it and when, what it did, every change it made, and the settings it ran with.
export default function InvoiceAutomationRunDetail({
  runId = null,
  projectName = '',
  clientId = null,
  onClose = () => {},
}) {
  const loadRunDetail = useCallback(() => InvoiceAutomationService.GetInvoiceAutomationRunDetail(runId), [runId]);
  const {
    data: runDetail,
    error,
    isLoading,
  } = useBackendData(loadRunDetail, 'Error! ErrorCode: IARD28. Failed to load the automatic invoicing run.');

  function getFacts(run) {
    const finishedOn = run.FinishedOnUtc ? dateTimeHelper.utcToLocalYYYYsMMsDDsHHsMM(run.FinishedOnUtc) : null;
    return [
      { label: 'Started by', value: InvoiceAutomationRunItem.getStartedBy(run) },
      { label: 'Started', value: dateTimeHelper.utcToLocalYYYYsMMsDDsHHsMM(run.StartedOnUtc) },
      { label: 'Finished', value: finishedOn },
    ];
  }

  function renderBody() {
    if (isLoading) {
      return <Loading />;
    }
    if (runDetail === null) {
      return null;
    }

    const changeItems = runDetail.changes.map((change) => new InvoiceAutomationRunChangeItem(change));
    return (
      <div className='iauto-run-detail'>
        <FactChips facts={getFacts(new InvoiceAutomationRunItem(runDetail.run))} />
        <InvoiceAutomationRunResult result={runDetail.run} />
        <section className='iauto-run-section'>
          <h4>What it changed</h4>
          <DataTable
            itemList={changeItems}
            type={InvoiceAutomationRunChangeItem}
            selectable={false}
            thereIsNoSuchRowMessage='The run changed nothing.'
          />
        </section>
        <section className='iauto-run-section'>
          <h4>The settings it ran with</h4>
          <InvoiceAutomationRunSettings
            settingsSnapshot={runDetail.settingsSnapshot}
            otherProjects={runDetail.otherProjects}
            clientId={clientId}
          />
        </section>
      </div>
    );
  }

  return (
    <DialogWindow
      title='Automatic Invoicing Run'
      eyebrow={projectName}
      iconName='fa-solid fa-clock-rotate-left'
      compact={false}
      errorText={error}
      buttons={<DialogCloseButton onClick={onClose} />}
      onClose={onClose}
    >
      {renderBody()}
    </DialogWindow>
  );
}
